let epoch = 0;
const resetListeners = new Set<() => void>();
let pendingCounter = () => 0;
export const sessionEpoch = () => epoch;
export const advanceSessionEpoch = () => ++epoch;
export function onSessionReset(fn: () => void) { resetListeners.add(fn); return () => { resetListeners.delete(fn); }; }
export function notifySessionReset() { advanceSessionEpoch(); resetListeners.forEach(fn => fn()); }
export function registerPendingCounter(fn: () => number) { pendingCounter = fn; }
export const pendingOperationCount = () => pendingCounter();
